@if (!cargando) {
  <div class="bg-white p-4 rounded-2xl border border-gray-100 shadow-xs">
    <div class="flex items-center mb-2">
      <div class="w-8 h-8 rounded-lg flex items-center justify-center mr-3" [class]="color">
        <img [src]="'assets/img/iconos/' + icono" alt="" height="20" width="20">
      </div>
      <div>
        <h4 class="text-sm font-medium">{{ titulo | translate }}</h4>
        <p class="text-xs text-gray-500">{{ subtitulo | translate }}</p>
      </div>
    </div>
  </div>
} @else {
  <div class="bg-white p-4 rounded-2xl border border-gray-100 shadow-xs animate-pulse">
    <div class="flex items-center mb-2">
      <div class="w-8 h-8 rounded-lg mr-3 bg-gray-200"></div>
      <div>
        <div class="h-4 w-24 bg-gray-200 rounded-sm mb-1"></div>
        <div class="h-3 w-16 bg-gray-200 rounded-sm"></div>
      </div>
    </div>
  </div>
}
